import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css'; // Import the CSS file
const logo_404 = require('../../assets/images/404_logo.png');

const NotFoundPage = () => {
    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <img
                    src={logo_404}
                    alt="404 placeholder"
                    className="not-found-image"
                />
                <div className="not-found-text">
                    <h1>404</h1>
                    <h3>Something's missing.</h3>
                    <p className="tkmr_gray_primary">The page you are looking for is missing or you assembled the link incorrectly.</p>
                    <Link to="/" className="home-link">Return to Home</Link>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
